import { Phone, Mail, MapPin, Clock, ListChecks, ArrowRight, FileDown } from "lucide-react";
import { Link } from "react-router-dom";
import FadeUp from "../components/FadeUp";
import ContactForm from "../components/ContactForm";
import { COMPANY } from "../lib/constants";
import { STOCK } from "../lib/stock";

export default function Contact() {
    return (
        <main data-testid="contact-page" className="bg-[#050505]">
            <section className="relative pt-40 pb-16 overflow-hidden">
                <div className="absolute inset-0">
                    <img
                        src={STOCK.contactHero}
                        alt=""
                        aria-hidden="true"
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-r from-[#050505] via-[#050505]/85 to-[#050505]/30" />
                    <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/70 via-transparent to-[#050505]" />
                </div>
                <div className="container-bevel relative z-10">
                    <FadeUp>
                        <span className="overline">Contact</span>
                    </FadeUp>
                    <FadeUp delay={1}>
                        <h1 className="font-display text-5xl md:text-7xl mt-6 leading-[0.95] max-w-4xl">
                            Start your{" "}
                            <span className="text-[#F5A623]">project.</span>
                        </h1>
                    </FadeUp>
                    <FadeUp delay={2}>
                        <p className="mt-8 text-lg text-white/65 max-w-2xl leading-relaxed">
                            Tell us about the property and your goals. We will
                            reach out within 24 hours to schedule a free
                            walkthrough or consult.
                        </p>
                    </FadeUp>
                    <FadeUp delay={3}>
                        <div className="mt-8 flex flex-col sm:flex-row gap-3">
                            <Link
                                to="/project-checklist"
                                data-testid="contact-checklist-cta"
                                className="inline-flex items-center gap-3 border border-[#F5A623]/40 bg-[#F5A623]/10 hover:bg-[#F5A623]/20 transition-colors px-5 py-3 text-sm text-[#F5A623]"
                            >
                                <ListChecks size={16} />
                                <span className="uppercase tracking-[0.18em] font-semibold">
                                    Use the project checklist
                                </span>
                                <ArrowRight size={14} />
                            </Link>
                            <a
                                href="/bevel-services-checklist.pdf"
                                download
                                data-testid="contact-checklist-pdf"
                                className="inline-flex items-center gap-3 border border-white/15 bg-transparent hover:border-white/40 transition-colors px-5 py-3 text-sm text-white/80 hover:text-white"
                            >
                                <FileDown size={16} />
                                <span className="uppercase tracking-[0.18em] font-semibold">
                                    Download checklist (PDF)
                                </span>
                            </a>
                        </div>
                    </FadeUp>
                </div>
            </section>

            <section className="pb-24">
                <div className="container-bevel grid grid-cols-1 lg:grid-cols-12 gap-10">
                    <FadeUp className="lg:col-span-4">
                        <div className="border border-white/10 bg-[#0A0A0A] p-8">
                            <span className="overline">Direct Line</span>
                            <ul className="mt-6 space-y-6 text-sm">
                                <li className="flex items-start gap-4">
                                    <Phone
                                        size={18}
                                        className="text-[#F5A623] mt-0.5"
                                    />
                                    <div>
                                        <div className="text-white/50 text-xs uppercase tracking-[0.2em]">
                                            Phone
                                        </div>
                                        <a
                                            href={COMPANY.phoneHref}
                                            className="text-white hover:text-[#F5A623] transition-colors text-base mt-1 inline-block"
                                            data-testid="contact-info-phone"
                                        >
                                            {COMPANY.phone}
                                        </a>
                                    </div>
                                </li>
                                <li className="flex items-start gap-4">
                                    <Mail
                                        size={18}
                                        className="text-[#F5A623] mt-0.5"
                                    />
                                    <div>
                                        <div className="text-white/50 text-xs uppercase tracking-[0.2em]">
                                            Email
                                        </div>
                                        <a
                                            href={COMPANY.emailHref}
                                            className="text-white hover:text-[#F5A623] transition-colors text-base mt-1 inline-block break-all"
                                            data-testid="contact-info-email"
                                        >
                                            {COMPANY.email}
                                        </a>
                                    </div>
                                </li>
                                <li className="flex items-start gap-4">
                                    <MapPin
                                        size={18}
                                        className="text-[#F5A623] mt-0.5"
                                    />
                                    <div>
                                        <div className="text-white/50 text-xs uppercase tracking-[0.2em]">
                                            Office
                                        </div>
                                        <div
                                            className="text-white text-base mt-1"
                                            data-testid="contact-info-address"
                                        >
                                            {COMPANY.address}
                                        </div>
                                    </div>
                                </li>
                                <li className="flex items-start gap-4">
                                    <Clock
                                        size={18}
                                        className="text-[#F5A623] mt-0.5"
                                    />
                                    <div>
                                        <div className="text-white/50 text-xs uppercase tracking-[0.2em]">
                                            Response
                                        </div>
                                        <div className="text-white text-base mt-1">
                                            Within 24 hours, Mon to Fri
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </FadeUp>

                    <FadeUp className="lg:col-span-8" delay={1}>
                        <ContactForm />
                    </FadeUp>
                </div>
            </section>
        </main>
    );
}
